import React, { lazy } from "react";
import routes from "constants/routes";
import { IRouteConfig } from "components/route/RouteMap";

const ROUTES: IRouteConfig[] = [
  {
    path: routes.ADMIN_DASHBOARD,
    exact: true,
    component: lazy(() => import("./dashboard/DashboardView")),
  },
  {
    path: routes.ADMIN_USERS,
    exact: true,
    component: lazy(() => import("./users/UsersListView")),
  },
  {
    path: routes.ADMIN_STATIONS,
    exact: true,
    component: lazy(() => import("./stations/list/StationsListView")),
  },
  {
    path: [routes.ADMIN_ADD_STATION, routes.ADMIN_EDIT_STATION],
    exact: true,
    component: lazy(() => import("./stations/create/AddStationView")),
  },
  {
    path: routes.ADMIN_DEVICE_TYPES,
    exact: true,
    component: lazy(() => import("./deviceTypes/list/DeviceTypesListView")),
  },
  {
    path: [routes.ADMIN_ADD_DEVICE_TYPE, routes.ADMIN_EDIT_DEVICE_TYPE],
    exact: true,
    component: lazy(() => import("./deviceTypes/create/addDeviceTypeView")),
  },
  {
    path: routes.ADMIN_ADD_DEVICE_TYPE_DETAIL,
    exact: true,
    component: React.lazy(
      () => import("./deviceTypes/detail/DeviceTypeDetailView")
    ),
  },
  {
    redirect: true,
    path: routes.ADMIN_DASHBOARD,
  },
];

export default ROUTES;
